
import { useTranslation } from 'react-i18next';

export default function DrivingHero() {
  const { t } = useTranslation();

  const whatsappNumber = '81909289552';
  const whatsappMessage = encodeURIComponent('Hello, I would like to book the Driving Assistant service.\nDate:\nTime:\nNumber of people:');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f551ab700e725806250ad1b548df8d1f.jpg"
          alt="Driving Assistant Service"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/50 rounded-full px-6 py-2 mb-6">
          <i className="ri-shield-check-line text-amber-400 text-lg"></i>
          <span className="text-amber-300 text-sm font-medium whitespace-nowrap">Not a Transportation Business</span>
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Driving<br className="md:hidden" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600"> Assistant</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-200 mb-4 leading-relaxed">
          Premium Rental Car Driving Support Service
        </p>

        <p className="text-base md:text-lg text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          We provide professional driving assistance for rental cars arranged by our guests.<br />
          This service does not include vehicle rental or paid transportation.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://line.me/ti/p/~yokota0809"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-r from-amber-500 to-yellow-600 text-black px-10 py-4 rounded-full font-bold text-lg hover:from-amber-400 hover:to-yellow-500 transition-all duration-300 shadow-lg hover:shadow-amber-500/50 flex items-center gap-3 whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-line-fill text-2xl"></i>
            <span>Book via LINE</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white px-10 py-4 rounded-full font-bold text-lg hover:from-[#20BA5A] hover:to-[#0F7A6A] transition-all duration-300 shadow-lg hover:shadow-green-500/50 flex items-center gap-3 whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <span>Book via WhatsApp</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="#pricing"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-10 py-4 rounded-full font-bold text-lg hover:bg-white/20 transition-all duration-300 flex items-center gap-2 whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <span>View Pricing</span>
            <i className="ri-arrow-down-line text-xl"></i>
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 flex flex-wrap justify-center gap-6 text-sm text-gray-300">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-fill text-amber-400 text-lg"></i>
            <span>Insurance Required</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-user-star-fill text-amber-400 text-lg"></i>
            <span>Experienced Drivers</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-map-pin-fill text-amber-400 text-lg"></i>
            <span>Tokyo Area Coverage</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}